import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ClientePendienteDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
export const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.NombreCliente }) },
    { title: "Saldo (facturas)", cell: x => ({ data: x.SaldoFacturas, view: kea.formatCurrency }) },
    { title: "Facturas pendientes", cell: x => ({ data: x.FacturasPendientes }) },
    { title: "Facturas vencidas", cell: x => ({ data: x.FacturasVencidas }) },
];




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/viajes/modales/nuevoviaje/multicliente/columns.tsx